import React from 'react'
import { PRINT_STATUS } from '../../constants'

const PrintStateContext = React.createContext(PRINT_STATUS.NO_PRINT)

export { PrintStateContext }
